module.exports = __webpack_public_path__ + "img/our3.444384ea.png";